<div class="app-shell">
    <aside class="admin-sidebar" [class.collapsed]="sidebarCollapsed">
        <div class="sidebar-top">
            <div class="admin-logo" *ngIf="!sidebarCollapsed">
                <img width="110" alt="Tmeic" src="assets/images/Tmeic-logo.png" />
            </div>
            <button class="hamburger-btn" type="button" (click)="toggleSidebar()" title="Toggle menu">
                <i class="ri-menu-line"></i>
            </button>
        </div>

        <div class="admin-section">
            <span class="admin-section-label" *ngIf="!sidebarCollapsed">{{ sidebarSectionLabel() }}</span>
            <ul class="menu-list">
                @for (item of sidebarMenuItems(); track item) {
                    <li class="menu-item">
                        <a [routerLink]="item.routerLink"
                           class="menu-link"
                           routerLinkActive="active-menu-link"
                           [routerLinkActiveOptions]="{ exact: false }">
                            <i class="{{ item.icon }}"></i>
                            <span class="menu-text">{{ item.label }}</span>
                        </a>
                    </li>
                }
            </ul>
        </div>

        <button class="menu-link logout-link" type="button" (click)="onLogout()">
            <i class="ri-logout-circle-r-line"></i>
            <span class="menu-text">Logout</span>
        </button>
    </aside>

    <div class="app-main">
        <div class="toolbar" role="banner">
            <app-top-menu></app-top-menu>
        </div>

        <div class="content">
            <router-outlet></router-outlet>
        </div>
    </div>

    <app-chat-bubble></app-chat-bubble>
</div>
